<div class="container-sm-fluid px-sm-4" [class.pt-3]="!embedded">
    <dx-tabs
        keyExpr="type"
        [items]="tabs"
        [selectedItemKeys]="[selectedTab]"
        [showNavButtons]="false"
        stylingMode="primary"
        class="mb-2"
        (onItemClick)="onTabClick($event.itemData.type)"
    ></dx-tabs>
</div>
@switch (selectedTab) {
    @case (TabType.Vacation) {
        <app-vacations [employeeId]="employeeId" [offset]="offset"></app-vacations>
    }
    @case (TabType.LieuDay) {
        <app-lieu-days [employeeId]="employeeId" [offset]="offset"></app-lieu-days>
    }
    @case (TabType.PersonalTime) {
        <app-personal-times [employeeId]="employeeId" [offset]="offset"></app-personal-times>
    }
    @case (TabType.FloaterDay) {
        <app-floater-days [employeeId]="employeeId" [offset]="offset"></app-floater-days>
    }
    @case (TabType.LeaveOfAbsence) {
        <app-absences [employeeId]="employeeId" [offset]="offset"></app-absences>
    }
    @case (TabType.AgencyTimeOff) {
        <app-agency-time-offs [employeeId]="employeeId" [offset]="offset"></app-agency-time-offs>
    }
}
